export default __webpack_public_path__ + "static/media/menu_icon03.9873748e.png";